<div>
	<p-dialog styleClass="prtg-history-dialog" appendTo="body" [(visible)]="visible" (onHide)="hide()" [modal]="true" [resizable]="false"
			  [style]="{'width': '920px', 'height': '700px'}">

		<p-header>
			<span>PRTG / Device / Sensor Values</span>
		</p-header>

		<div>

			<prtg-history [visible]="visible" [monitorType]="monitorType" [monitorPolicyGuid]="monitorPolicyGuid"></prtg-history>

		</div>

		<p-footer>
			<button type="button" pButton icon="fa fa-close" (click)="hide()" label="Close"></button>
		</p-footer>

	</p-dialog>

</div>